import { useEffect, useState } from "react";

import { useTranslate } from "@/providers/context";

const Counter = ({ text, count }: { text: string; count: string }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="text-[28px] font-bold leading-[38px]">{count}</div>
      <div>{text}</div>
    </div>
  );
};
const Colon = () => {
  return <div className="text-[28px] font-bold leading-[38px]">:</div>;
};

/**
 *
 * @param startDate - The start time in ISO like format YYYY-MM-DD HH:MM:SS in the local timezone
 * @constructor
 */
export const LiveStreamCountdown = ({ startDate }: { startDate: Date }) => {
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [hoursRemaining, setHoursRemaining] = useState(0);
  const [minutesRemaining, setMinutesRemaining] = useState(0);
  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const { translate, formatDetailedDatetime } = useTranslate();

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = startDate.getTime() - now;

      if (distance < 0) {
        // Time is up, stop the countdown
        clearInterval(interval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setDaysRemaining(days);
      setHoursRemaining(hours);
      setMinutesRemaining(minutes);
      setSecondsRemaining(seconds);
    };

    // Update once per second
    const interval = setInterval(updateCountdown, 1000);
    // Call updateCountdown immediately to initialize state
    updateCountdown();

    return () => clearInterval(interval);
  }, [startDate]);

  return (
    <div className="p2-regular flex h-full w-full flex-col items-center justify-center rounded-xl bg-surface-overlay-80 text-white">
      <>{translate("Livestream countdown")}</>
      <div className="mt-3 rounded-lg bg-black px-2 py-[6px]">
        {formatDetailedDatetime(startDate)}
      </div>
      <div className="mt-10 flex gap-4">
        <Counter
          count={String(daysRemaining).padStart(2, "0")}
          text={translate("days")}
        />
        <Colon />
        <Counter
          count={String(hoursRemaining).padStart(2, "0")}
          text={translate("hours")}
        />
        <Colon />
        <Counter
          count={String(minutesRemaining).padStart(2, "0")}
          text={translate("minutes")}
        />
        <Colon />
        <Counter
          count={String(secondsRemaining).padStart(2, "0")}
          text={translate("seconds")}
        />
      </div>
    </div>
  );
};
